/** Tab ids that should show the "New" badge in primary nav and search.
 *  To remove a badge when launch is done: delete its entry from NAV_NEW_BADGE_ID_TO_PATH — both Sets update automatically. */
const NAV_NEW_BADGE_ID_TO_PATH: Record<string, string> = {
  home: '/home',
  'checkout-subscriptions': '/subscriptions'
}

export const NAV_NEW_BADGE_TAB_IDS = new Set(Object.keys(NAV_NEW_BADGE_ID_TO_PATH))

export const NAV_NEW_BADGE_PATHS = new Set(Object.values(NAV_NEW_BADGE_ID_TO_PATH))

export const shouldShowNavNewBadgeById = (id: string) => NAV_NEW_BADGE_TAB_IDS.has(id)

export const shouldShowNavNewBadgeByPath = (path: string) => {
  const normalizedPath = path.split('?')[0].split('#')[0]
  return NAV_NEW_BADGE_PATHS.has(normalizedPath)
}

const shimmerDismissKey = (tabId: string) => `nav-shimmer-dismissed:${tabId}`

export const isNavShimmerDismissed = (tabId: string): boolean => {
  if (typeof window === 'undefined') return true
  return localStorage.getItem(shimmerDismissKey(tabId)) === 'true'
}

export const dismissNavShimmer = (tabId: string): void => {
  if (typeof window === 'undefined') return
  localStorage.setItem(shimmerDismissKey(tabId), 'true')
}

const HOME_STARTUP_DISMISS_KEY = 'home-startup-dismissed'

export const isHomeStartupDismissed = (): boolean => {
  if (typeof window === 'undefined') return true
  return localStorage.getItem(HOME_STARTUP_DISMISS_KEY) === 'true'
}

export const dismissHomeStartup = (): void => {
  if (typeof window === 'undefined') return
  localStorage.setItem(HOME_STARTUP_DISMISS_KEY, 'true')
}
